













import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SubmitTransition extends Vue {
  @Prop({ type: String, default: '' })
  statusTxt!: string

  @Prop({ type: String, default: '' })
  btnTxt!: string

  @Prop({ type: Number, default: 5 })
  time!: number

  timer: any = null
  timeNum = -1
  successImg = require('../../assets/image/icon-success.png')

  created() {
    this.timeNum = this.time
    this.initTimer()
  }

  initTimer() {
    this.timer = setInterval(() => {
      if (this.timeNum < 1) {
        this.$emit('back')
        return clearInterval(this.timer)
      }
      this.timeNum -= 1
    }, 1000)
  }
}
